import { render, staticRenderFns } from "./VisitDetailAdd.vue?vue&type=template&id=f3071508&scoped=true"
import script from "./VisitDetailAdd.vue?vue&type=script&lang=js"
export * from "./VisitDetailAdd.vue?vue&type=script&lang=js"
import style0 from "./VisitDetailAdd.vue?vue&type=style&index=0&id=f3071508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3071508",
  null
  
)

export default component.exports